export interface UserSummary {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  point: number;
  createdAt: Date;
  updatedAt: Date;
}

export const userSummaryFromResponse = (responseData: any): UserSummary => ({
  id: responseData.id,
  firstName: responseData.first_name,
  lastName: responseData.last_name,
  email: responseData.email,
  phone: responseData.phone,
  point: responseData.point,
  createdAt: new Date(responseData.created_at),
  updatedAt: new Date(responseData.updated_at),
});
